/**
 * @generated SignedSource<<68e5410da69133c2fd2d0c4c9c8cb5f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateCustomFieldDefinitionInput = {
  key?: string | null;
  displayName?: string | null;
  readOnly?: boolean | null;
  type?: string | null;
  entityType?: string | null;
  avaRef?: number | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateCustomFieldDefinitionMutation$variables = {
  input: CreateCustomFieldDefinitionInput;
};
export type CreateCustomFieldDefinitionMutation$data = {
  readonly createCustomFieldDefinition: {
    readonly customFieldDefinition: {
      readonly node: {
        readonly id: string;
        readonly __typename: string;
        readonly key: string;
        readonly displayName: string;
        readonly entityType: string;
        readonly avaRef: number | null;
        readonly type: string;
        readonly readOnly?: boolean;
      } | null;
    } | null;
  } | null;
};
export type CreateCustomFieldDefinitionMutation$rawResponse = {
  readonly createCustomFieldDefinition: {
    readonly customFieldDefinition: {
      readonly node: {
        readonly id: string;
        readonly __typename: "TextCustomField";
        readonly key: string;
        readonly displayName: string;
        readonly entityType: string;
        readonly avaRef: number | null;
        readonly type: string;
        readonly readOnly: boolean;
      } | {
        readonly id: string;
        readonly __typename: "IntegerCustomField";
        readonly key: string;
        readonly displayName: string;
        readonly entityType: string;
        readonly avaRef: number | null;
        readonly type: string;
        readonly readOnly: boolean;
      } | {
        readonly id: string;
        readonly __typename: string;
        readonly key: string;
        readonly displayName: string;
        readonly entityType: string;
        readonly avaRef: number | null;
        readonly type: string;
      } | null;
    } | null;
  } | null;
};
export type CreateCustomFieldDefinitionMutation = {
  variables: CreateCustomFieldDefinitionMutation$variables;
  response: CreateCustomFieldDefinitionMutation$data;
  rawResponse: CreateCustomFieldDefinitionMutation$rawResponse;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "readOnly",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateCustomFieldDefinitionPayload",
    "kind": "LinkedField",
    "name": "createCustomFieldDefinition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomFieldDefinitionV2TypeEdge",
        "kind": "LinkedField",
        "name": "customFieldDefinition",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entityType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avaRef",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v1/*: any*/),
                "type": "TextCustomField",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v1/*: any*/),
                "type": "IntegerCustomField",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateCustomFieldDefinitionMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateCustomFieldDefinitionMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "075d350efc05de6764fc0db228ca1a1a",
    "id": null,
    "metadata": {},
    "name": "CreateCustomFieldDefinitionMutation",
    "operationKind": "mutation",
    "text": "mutation CreateCustomFieldDefinitionMutation(\n  $input: CreateCustomFieldDefinitionInput!\n) {\n  createCustomFieldDefinition(input: $input) {\n    customFieldDefinition {\n      node {\n        id\n        __typename\n        key\n        displayName\n        entityType\n        avaRef\n        type\n        ... on TextCustomField {\n          readOnly\n        }\n        ... on IntegerCustomField {\n          readOnly\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "48ac35633be1351ea593f17f19d6a091";

export default node;
